import styled from 'styled-components'

export const ColoredDiv = styled.div<{ color: string }>((props) => ({
  color: `${props.color}`,
  border: '1px solid white',
}))
